import React from 'react';
import { Box, Typography, Grid, Paper, Link } from '@mui/material';
import selfcareImage from '../assets/Slogan-01.jpeg';
import {Helmet} from "react-helmet";

function aboutus() {
  const paircare = (
    <Link
      href="https://www.paircare.ai/"
      target="_blank"
      rel="noopener"
    >
      PairCare
    </Link>
  );

  const pairtech = (
    <Link
      href="https://www.pairtech.ai/"
      target="_blank"
      rel="noopener"
    >
      Pair Tech LLC
    </Link>
  );
  return (
     <Box sx={{ maxWidth: "700px", padding: "20px", margin: "auto" }}>
       <Helmet>
         <title>PairCare - About Us</title>
       </Helmet>

      {/* Expanded Top Image */}
      <Box
        sx={{
          width: '100%',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}
      >
        <img alt={"About paircare.ai"} src={selfcareImage} width={"100%"} style={{borderRadius: "20px"}}/>
      </Box>

      {/* Who We Are Section */}
      <Box sx={{marginTop: "10px", marginBottom:"10px"}}>
        <Typography variant="h5" gutterBottom sx={{ textAlign: 'justify' }}>
          Who We Are
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'justify' }}>
          Welcome to {paircare} – a subsidiary of {pairtech} and your trusted business partner in connecting self-care service
          providers with the clients who need them most. Our cutting-edge,
          AI-driven platform is designed to empower professionals—from massage
          therapists and estheticians to personal trainers, nutritionists,
          tutors, and financial advisors—to expand their reach and grow their
          practices. At {paircare}, we believe that every individual deserves access to quality self-care,
          and we're here to bridge the gap between dedicated service providers and
          those seeking wellness and personal growth. Just register your business in
          a few clicks, leverage our AI tools to build your digital presence, and
          watch your client base grow.
        </Typography>
      </Box>

      {/* What We Offer Section */}
      <Box sx={{ p: 3, backgroundColor: '#f5f5f5', borderRadius: "20px" }}>
        <Typography variant="h5" gutterBottom sx={{ textAlign: 'justify' }}>
          What We Offer
        </Typography>
        <Grid container spacing={4} rowSpacing={6}>
          <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 2, height: '100%', borderRadius: 0 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                Scheduling
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                Our automated system estimates travel times and fills open slots to
                optimize your schedule.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 2, height: '100%', borderRadius: 0 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                Payment
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                In partnership with Stripe, we securely process transactions with
                multiple payment options.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 2, height: '100%', borderRadius: 0 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                Accounting
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                Our tools offer real-time financial insights, making budgeting and
                reporting effortless.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 2, height: '100%', borderRadius: 0 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                AI-driven Tools
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                Leverage variety of AI-driven tools to manage your business with maximum performance.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 2, height: '100%', borderRadius: 0 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                Advertising
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                Leverage innovative marketing approach to create compelling campaigns that
                boost your brand.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Paper elevation={3} sx={{ p: 2, height: '100%', borderRadius: 0 }}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 'bold', textAlign: 'center' }}
              >
                Safety
              </Typography>
              <Typography variant="body2" sx={{ textAlign: 'center' }}>
                Background checks ensure a secure environment for both providers
                and clients.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
        <Typography variant="body1" sx={{ mt: 6, textAlign: 'justify' }}>
          At {paircare}, we're more than just a platform—we're a community committed to enhancing the
          self-care experience for all. Join us today and discover how our innovative
          solutions can streamline your operations, expand your client base, and drive
          sustainable growth. Welcome to a new era of self-care.
        </Typography>
      </Box>

      {/* Our Mission Section */}
      <Box sx={{ marginTop: "10px", marginBottom: "10px" }}>
        <Typography variant="h5" gutterBottom sx={{ textAlign: 'justify' }}>
          Our Mission
        </Typography>
        <Typography variant="body1" sx={{ textAlign: 'justify' }}>
          At {paircare}, our mission is clear: to revolutionize the self-care industry by offering
          efficient, cost-effective solutions that benefit both providers and clients.
          Our suite of AI-powered tools streamlines operations—from scheduling to payments—so
          professionals can focus on what they do best. With our <strong>One-Stop Selfcare
          Shop™</strong>, we bring together all the essential features you need to manage and
          grow your practice, supporting our commitment to <strong>Affordable Selfcare for
          All™</strong>. We're dedicated to fostering a community where high-quality, accessible
          self-care services are just a click away, ensuring that both providers and clients
          thrive in a secure, user-friendly environment.
        </Typography>
      </Box>
    </Box>
  );
}

export default aboutus;
